import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsLinkPatternComponenent extends Component {
  // Services
  @service data;

  // Defaults
  shopTypeOptions = [];

  // Hooks
  constructor() {
    super(...arguments);

    this.shopTypeOptions = this.data.getCategories({
      'filter[type]': 'SHOP_TYPE',
    });
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openNewRecord=false openRecord=false}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='name' />
            <fieldset.field @property='description' @type='textarea' />
            <fieldset.field @property='pattern' />
            <fieldset.field @property='svgUrl' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='tradePartner'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='shopType'
              @type='select-record'
              @options={{this.shopTypeOptions}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
